import { GetStaticProps, GetStaticPropsContext, GetStaticPropsResult } from 'next';

import Component from './component';
import { Props } from './types';

export const getStaticProps: GetStaticProps = async (context: GetStaticPropsContext): Promise<GetStaticPropsResult<Props>> => {
    const locale = context.locale || context.defaultLocale || 'pl';

    return {
        props: {
            localTranslations: require(`locales/${locale}/pages/regulations`)?.default,
            metaTranslations: require(`locales/${locale}/pages/regulations`)?.meta,
        },
        revalidate: 10,
    };
};

export default Component;
